import axios from 'axios';
import { BASE_URL, DEFAULT_HEADERS } from './config';
import { setupInterceptors } from './interceptors';

const axiosInstance = axios.create({
    baseURL: BASE_URL, 
    headers: DEFAULT_HEADERS,
    withCredentials: true, // 👈 💡 هنا السر! يجبر المتصفح على إرسال الكوكيز عبر Port 8000 و Port 3000
});

// تفعيل المعالجات تلقائياً على النسخة المخصصة
setupInterceptors(axiosInstance);

// ✅ الحل: أي طلب جسمه FormData، نشيل الـ Content-Type الثابت (application/json)
// عشان المتصفح يحدد multipart/form-data مع الـ boundary الصحيح تلقائياً
axiosInstance.interceptors.request.use((config) => {
    if (config.data instanceof FormData) {
        delete config.headers['Content-Type'];
    }
    return config;
});

export default axiosInstance;